import "./confirm-choice-button.scss";

import { Button, Popover } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { NAMESPACES } from "@/i18n/constants";

export default function ConfirmChoiceButton({
    popperProps = {},
    confirmButtonProps = {},
    confirmationQuestion = undefined,
    confirmationText = undefined,
    children,
    onClick,
    color = undefined,
    disableOpen = false,
    ...otherProps
}) {
    const { t } = useTranslation(NAMESPACES.COMPONENTS, { keyPrefix: "confirm-choice-button" });
    const [open, setOpen] = React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState(undefined);
    const buttonProps = { ...otherProps };
    const confirmButtonText = confirmationText ?? children;

    return (
        <>
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={() => {
                    setAnchorEl(undefined);
                    setOpen(false);
                }}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "center",
                }}
                transformOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                }}
                {...popperProps}
                className={`${popperProps?.className || ""} ConfirmChoiceButton__popper`}
            >
                {confirmationQuestion || t("confirmation-question")}
                <Button
                    variant={"contained"}
                    color={color}
                    {...confirmButtonProps}
                    onClick={(e) => {
                        setOpen(false);
                        setAnchorEl(undefined);
                        onClick(e);
                    }}
                >
                    {confirmButtonText}
                </Button>
            </Popover>
            <Button
                color={color}
                {...buttonProps}
                onClick={(e) => {
                    if (!disableOpen) {
                        setAnchorEl(e.currentTarget);
                        setOpen(true);
                    }
                }}
            >
                {children}
            </Button>
        </>
    );
}
